import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { bem } from 'helpers/class-name';
import { makePath } from 'helpers/link-generation';
import { selectActiveVenue } from 'selectors/general';

import Message from 'components/Message';
import { Card } from 'components/Card';

import './ClassInsightsCalloutBanner.scss';

import { messages } from './ClassInsightsCalloutBanner.messages';

const { block, element } = bem('class-insights-callout-banner');

const ClassInsightsCalloutBanner = () => {
  const { venueId } = useSelector(selectActiveVenue);

  return (
    <Card flush className={block()}>
      <div className={element('header')}>
        <Message as="h5" message={messages.bannerTitle} />
        <Message as="span" className={element('badge')} message={messages.badgeText} />
      </div>
      <Message
        className={element('description')}
        message={messages.bannerDescription}
        values={{
          a: text => <Link to={makePath.classInsights({ venueId })}>{text}</Link>,
        }}
      />
    </Card>
  );
};

export default ClassInsightsCalloutBanner;
